export const AD_TYPE = {
  HOUSE_LOAN: "house_loan",
  RENT_CARD: "rent_card",
  MISO: "miso",
  MISO_MOVING: "miso_moving",
  MISO_INTERNET: "miso_internet",
  MISO_CLEANING: "miso_cleaning",
  FIRSTAM: "firstamerican",
};

export const MISO_SUBTYPES = [AD_TYPE.MISO_MOVING, AD_TYPE.MISO_INTERNET, AD_TYPE.MISO_CLEANING];

export const SPLASH_AD_TYPES = [AD_TYPE.RENT_CARD, AD_TYPE.HOUSE_LOAN, ...MISO_SUBTYPES];

export function supportsSplashAd(adType) {
  return SPLASH_AD_TYPES.includes(adType);
}
